import { Col, Row, SofturaTable, Card, Breadcrumb, EventHandler } from "client/CommonComponents";
import { useDispatch, useSelector } from "react-redux"
import { FilteringMode } from 'ka-table/enums';
import { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { base64ToArrayBuffer, saveByteArray } from "utils";
import { getApprovalHistoryDetailExcel, getApprovalHistoryReportDetails, setApprovalHistoryDetailExcel } from "Store/OrderManagement/ApprovalHistoryReport/ApprovalHistoryReportAction";
import excel from '../../../../assets/images/Excel.svg'
import permissions, { isAuthorized } from "client/utils/Permissions";
import './ApprovalHistoryReport.scss';

const ApprovalHistoryDetails = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    let { id } = useParams();

    const [data, setData] = useState<any>([])

    //selectors
    const {
        approvalHistoryReportDetails,
        approvalHistoryDetailExcel,
        getUserDetails
    }: any = useSelector((state: any) => ({
        approvalHistoryReportDetails: state?.ApprovalHistoryReportReducer?.approvalHistoryReportDetails,
        approvalHistoryDetailExcel: state?.ApprovalHistoryReportReducer?.approvalHistoryDetailExcel,
        getUserDetails: state.UserProfile.getUserDetails,
    }))

    useEffect(() => {
        if ((!isAuthorized(permissions.ViewHierarchy) && !isAuthorized(permissions.ViewApprovalHistory)) && getUserDetails?.permissions) {
            navigate(`/ordermanagement`)
        }
    }, [getUserDetails?.permissions])

    useEffect(() => {
        if (approvalHistoryReportDetails?.orderApprovalHistoryExcelVMs?.length > 0) {
            const tempData = approvalHistoryReportDetails?.orderApprovalHistoryExcelVMs?.map((item: any) => ({
                ...item,
                dateApproved: item?.dateApproved ? moment(item?.dateApproved).format("MM/DD/YYYY") : "",
            }))
            setData(tempData)
        } else {
            setData([])
        }
    }, [approvalHistoryReportDetails])

    useEffect(() => {
        if (id) {
            dispatch(getApprovalHistoryReportDetails(id))
        }
    }, [])

    useEffect(() => {
        if (approvalHistoryDetailExcel) {
            const byteArray = base64ToArrayBuffer(approvalHistoryDetailExcel)
            saveByteArray('Approval_History_Detail', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            dispatch(setApprovalHistoryDetailExcel(null))
        }
    }, [approvalHistoryDetailExcel])


    const columns = [
        {
            key: "approver",
            title: "Approver #",
            width: 210
        },
        {
            key: "title",
            title: "Title",
            width: 210
        },
        {
            key: "assignedApprover",
            title: "Assigned Approver",
            width: 210
        },
        {
            key: "actualApprover",
            title: "Actual Approver",
            width: 210
        },
        {
            key: "status",
            title: "Status",
            width: 210
        },
        {
            key: "dateApproved",
            title: "Date Approved",
            width: 210
        },
        {
            key: "comments",
            title: "Comments",
            width: 210
        }
    ];

    const breadcrumlist = [
        { text: 'Approval Management', key: 'f1', href: '/ordermanagement/approval', onClick: (e: any) => { e.preventDefault(); navigate("/ordermanagement/approval") } },
        { text: 'Approval List', key: 'f2', href: '/ordermanagement/approval', onClick: (e: any) => { e.preventDefault(); navigate("/ordermanagement/approval") } },
        { text: 'Approval History Details', key: 'f3' },
    ]


    const onExportExcel = () => {
        dispatch(getApprovalHistoryDetailExcel(id))
    }


    return (
        <div className='Approval-Dashboard mt-1'>
            <div className='breadCrumbBlock'>
                <button className='backButton mb-sm-2 mb-3' onClick={() => { navigate("/ordermanagement/approval") }} data-attribute="ApprovalHistoryDetails_Default_Button">
                    <span className="fa fa-chevron-left"></span>&nbsp;
                    Back
                </button>
                <div className="breadcrumbList">
                    <div className='order-1'><Breadcrumb items={breadcrumlist} maxDisplayedItems='5'  data-attribute="ApprovalHistoryDetails_Default_Breadcrumb" /></div>
                </div>
            </div>
            <Card data-attribute="ApprovalHistoryDetails_Default_Card">
                <Row className="top-section">
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <p>Approver History Details</p>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={12} className="mt-2 mb-2">
                        <Row className="approvalhistoryrow">

                            <Col xs={12} sm={12} md={6} lg={2} xl={1} className="approvalhistory_singleline mt-lg-0 mt-md-0 mt-2 ">
                                <div className="label mb-0 order_width">Order # :</div>
                                <span className="approvalHistoryDetailsText costCenter_text label">{approvalHistoryReportDetails?.orderId}</span>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={4} xl={2} className="approvalhistory_singleline mt-lg-0 mt-md-0 mt-2 ">
                                <div className="label mb-0 costCenter_width">Cost Center :</div>
                                <span className="approvalHistoryDetailsText costCenter_text label">{approvalHistoryReportDetails?.costCenter}</span>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} className="approvalhistory_singleline mt-lg-0 mt-md-3 mt-2">
                                <div className="label mb-0 w-25 requestType">Request Type :</div>
                                <span className="approvalHistoryDetailsText requestType_text label">{approvalHistoryReportDetails?.requestType}</span>
                            </Col>
                            <Col xs={12} sm={12} md={6} lg={3} xl={3} className="approvalhistory_singleline mt-lg-0 mt-md-3 mt-2">
                                <div className="label mb-0 approvalstatus_width">Approval Status : </div>
                                <span className="approvalHistoryDetailsText approvalstatus_text label">{approvalHistoryReportDetails?.status}</span>
                            </Col>
                            <Col xs={12} sm={12} md={12} lg={12} xl={3}>
                                <div className='mb-1 top-section approval-hierarchy'>
                                    <div className='clearfix'>
                                        <div className='btn-block-approvalhierarchy pull-right'>
                                            <div className={`excel-section-approvalhierarchy mt-1 ${true ? "" : "disable-export-excel"}`}>

                                                <EventHandler onEvent={onExportExcel} data-attribute="ApprovalHistoryDetails_Default_EventHandler">
                                                    <img
                                                        src={excel}
                                                        alt='excel'
                                                        className={`${data?.length ? "" : "disable-approval-list-excel"}`}
                                                    />
                                                </EventHandler>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <div className={`pe-0 ${data?.length != 0 ? "softura-table" : "softura-table paginationNav"}`}>
                        {true ?
                            <SofturaTable
                                data={data ?? []}
                                columns={columns}
                                sort={true}
                                defaultPageSize={10}
                                pageSizes={[10, 20, 50]}
                                globalSearch={false}
                                fixedHeader={true}
                                className="approvalHierarchy-grid"
                                filteringMode={FilteringMode.FilterRow}
                                isServerSide={true}
                                pagination={false}
                             data-attribute="ApprovalHistoryDetails_Default_Grid" />
                            : null}
                    </div>
                </Row>
            </Card>
        </div>
    )
}

export default ApprovalHistoryDetails